import cx from "classnames";
import {
  AddCircleFill,
  CheckCircleFill,
} from "@bloomberg/media-ui-iconography";

import { SelectTagsProps } from "./types";

import styles from "./styles.module.css";

export function Component({
  text,
  onClick = () => {},
  isDisabled = false,
  isSelected = false,
}: SelectTagsProps) {
  const handleOnClick = () => {
    onClick();
  };

  const classNames = cx(styles.selectTagContainer, {
    [styles.selected]: isSelected,
  });

  return (
    <button
      aria-pressed={isSelected}
      className={classNames}
      disabled={isDisabled}
      onClick={handleOnClick}
      type="button"
    >
      {isSelected ? (
        <CheckCircleFill />
      ) : (
        <AddCircleFill />
      )}
      <span className={styles.text}>{text}</span>
    </button>
  );
}

Component.displayName = "SelectTag.Component";
